import { Box, Modal, Button, IconButton } from "@mui/material";
import React, { useState, useRef } from "react";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
// import invoiceType from "../../data/invoiceType.json";
// import PaymentMode from "../../data/paymentMethod.json";
// import TaxType from "../../data/taxType.json";
// import StateCode from "../../data/stateCode.json";
// import CountryCode from "../../data/countryCode.json";
// import ClassificationCode from "../../data/classificationCode.json";
import csvfile from "../../assets/images/csv3.png";
import CloseIcon from "@mui/icons-material/Close";
import Papa from "papaparse";
import { useApiClient } from "context/ApiClientContext";
import ErrorAlert from "helper/errorAlert";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
};

function ImportButton() {
  const [fileName, setFileName] = React.useState("")
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setJsonData("");
    setOpen(false);
  };

  const apiClient = useApiClient();
  const fileinputRef = useRef(null)
  const [jsonData, setJsonData] = useState(null);
  const companyId = localStorage.getItem("companyId");
  // const todayDate = moment().format("YYYY-MM-DD");
  const todayDate = moment().format("YYYY-MM-DDTHH:mm");
  const requiredHeaders = [
    "Invoice Version",
    "Invoice Type",
    "Invoice Number",
    "Invoice Ref Number",
    // "Signature",
    // "Issuance Date",
    "Currency Code",
    "Exchange Rate",
    "Bill Frequency",
    "Invoice Date",
    // "Invoice Due Date",
    "Payment Mode",
    "Payment Term",
    "Deposit Amount",
    "Deposit Date",
    "Deposit Number",
    "Deposit Ref Number",
    // "Submission UUID",
    // "Document UUID",
    // "Document Link",
    "Total Exclude Tax",
    "Total Include Tax",
    "Total Payable Amount",
    "Total Net Amount",
    "Total Discount Amount",
    "Total Charge Amount",
    "Total Tax Amount",
    "Rounding Amount",
    "Total Taxable Amount",
    "Total Tax Type Amount",
    "Tax Type",
    // "Remark",
    "E-Invoice Number",
    "Import Number",
    "Incoterms",
    "FTA Info",
    "Exporter Account Id",
    "Export Number",
    "Supplier Name",
    "Supplier TIN",
    "Supplier Identification Type",
    "Supplier Identification Number",
    "Supplier SST",
    "Supplier Tourism Tax",
    "Supplier Email",
    "Supplier MSIC Number",
    "Supplier Bussiness Nature",
    "Supplier Address 1",
    "Supplier Address 2",
    "Supplier Address 3",
    "Supplier Zipcode",
    "Supplier City",
    "Supplier State",
    "Supplier Country",
    "Supplier Contact Number",
    "Buyer Name",
    "Buyer TIN",
    "Buyer Identification Type",
    "Buyer Identification Number", //Buyer id value (BRN, NRIC, Army)
    "Buyer SST",
    "Buyer Email",
    "Buyer Address 1",
    "Buyer Address 2",
    "Buyer Address 3",
    "Buyer Zipcode",
    "Buyer City",
    "Buyer State",
    "Buyer Country",
    "Buyer Contact Number",
    "Ship Recipient Name",
    "Ship Recipient Address 1",
    "Ship Recipient Address 2",
    "Ship Recipient Address 3",
    "Ship Recipient Zipcode",
    "Ship Recipient City",
    "Ship Recipient State",
    "Ship Recipient Country",
    "Ship Recipient TIN",
    "Ship Recipient Identification Type",
    "Ship Recipient Identification Value",
    "Line Id",
    "Line Classification Id",
    "Line Description",
    "Line Unit Price",
    "Line Tax Type", //value
    "Line Tax Rate",
    "Line Tax Amount",
    "Line Tax Exemption Description",
    "Line Tax Exemption Amount",
    "Line Total Amount",
    "Line Total Exclude Tax",
    "Line Quantity",
    "Line Unit of Measurement",
    "Line Discount Rate",
    "Line Discount Amount",
    "Line Charge Rate",
    "Line Charge Amount",
    "Line Tariff Code",
    "Line Origin Country",
  ];

  function mappingValue(invoice, field, mapping, newField) {
    if (field in invoice) {
      const dataField = invoice[field];
      const matchingDescription = mapping.find((item) => {
        if (item.Description === dataField) {
          return item;
        }
      });
      if (matchingDescription) {
        const code = matchingDescription.Code;
        invoice[newField] = code;
      }
    }
  }

  function mappingCode(invoice, field, mapping, newField) {
    if (field in invoice) {
      const dataField = invoice[field];
      const matchingCode = mapping.find(
        (item) => {

          if (item.Code === dataField) {
            return item
          }
        }
      );
      if (matchingCode) {
        const value = matchingCode.Description;
        invoice[newField] = value;
      }
    }
  }

  const handleFileUpload = (file) => {

    Papa.parse(file, {
      beforeFirstChunk: (chunk) => {
        let cleanedChunk = chunk.replace(/"/g, '');
        const rows = cleanedChunk.split(/[\r\n]+/);
        const headers = rows[0].split(',');

        if (rows.length === 1 || rows[1] === '') {
          toast.error(`No data. Please select new file.`, {
            position: "top-right",
            stopOnFocus: true,
          });
        }
        const missingHeaders = requiredHeaders.filter(header => !headers.includes(header));
        if (missingHeaders.length > 0) {
          toast.error(`The following required headers are missing or invalid: ${missingHeaders.join(', ')}`, {
            position: "top-right",
            stopOnFocus: true,
          });
          return null;
        }

        const invalidHeaders = headers.filter(header => !requiredHeaders.includes(header.trim()));
        if (invalidHeaders.length > 0) {
          toast.error(`The following headers are invalid: ${invalidHeaders.join(', ')}`, {
            position: "top-right",
            stopOnFocus: true,
          });
          return null;
        }


        const extraHeaders = headers.filter(header => !requiredHeaders.includes(header));
        if (extraHeaders.length > 0) {
          toast.error(`The following headers are not required: ${extraHeaders.join(', ')}`, {
            position: "top-right",
            stopOnFocus: true,
          });
          return null;
        }
        return chunk;
      },
      complete: function (results) {
        setFileName(file.name)

        if (results.data.length > 0) {
          transformAndUseData(results.data);
        }
      },
      header: true,
      skipEmptyLines: true,
      transformHeader: (header) => {
        const headerMapping = {
          "Invoice Version": "version",
          "Invoice Type": "typeCode_Value",
          "Invoice Number": "docNum",
          "Invoice Ref Number": "refDocNum",
          // "Signature": "signature",
          // "Issuance Date": "issueDateTime",
          "Currency Code": "currency",
          "Exchange Rate": "exchangeRate",
          "Bill Frequency": "billFreq",
          "Invoice Date": "docDate",
          "Invoice Due Date": "docDueDate",
          "Payment Mode": "payMode_Value",
          "Payment Term": "payTerm",
          "Deposit Amount": "depositAmt",
          "Deposit Date": "depositDateTime",
          "Deposit Number": "depositNum",
          "Deposit Ref Number": "depositRefNum",
          // "Submission UUID": "submissionuuid",
          // "Document UUID": "docuuid",
          // "Document Link": "doclink",
          "Total Exclude Tax": "total_ExcludeTax",
          "Total Include Tax": "total_IncludeTax",
          "Total Payable Amount": "total_PayableAmt",
          "Total Net Amount": "total_NettAmt",
          "Total Discount Amount": "total_DiscAmt",
          "Total Charge Amount": "total_ChargeAmt",
          "Total Tax Amount": "total_TaxAmt",
          "Rounding Amount": "roundingAmt",
          "Total Taxable Amount": "total_TaxableAmt",
          "Total Tax Type Amount": "total_TaxTypeAmt",
          "Tax Type": "taxType_Value",
          // "Remark": "remark",
          "E-Invoice Number": "eDocNum",
          "Import Number": "importNum",
          "Incoterms": "incoterms",
          "FTA Info": "ftaInfo",
          "Exporter Account Id": "exporterAcctId",
          "Export Number": "exportNum",
          "Supplier Name": "supplier_Name",
          "Supplier TIN": "supplier_Tin",
          "Supplier Identification Type": "supplier_BizType",
          "Supplier Identification Number": "supplier_BizValue",
          "Supplier SST": "supplier_SST",
          "Supplier Tourism Tax": "supplier_TourismTax",
          "Supplier Email": "supplier_Email",
          "Supplier MSIC Number": "supplier_MSIC",
          "Supplier Bussiness Nature": "supplier_BizNature",
          "Supplier Address 1": "supplier_Addr0",
          "Supplier Address 2": "supplier_Addr1",
          "Supplier Address 3": "supplier_Addr2",
          "Supplier Zipcode": "supplier_Zipcode",
          "Supplier City": "supplier_City",
          "Supplier State": "supplier_State",
          "Supplier Country": "supplier_Country",
          "Supplier Contact Number": "supplier_Contact",
          "Buyer Name": "buyer_Name",
          "Buyer TIN": "buyer_Tin",
          "Buyer Identification Type": "buyer_BizType",
          "Buyer Identification Number": "buyer_BizValue",
          "Buyer SST": "buyer_SST",
          "Buyer Email": "buyer_Email",
          "Buyer Address 1": "buyer_Addr0",
          "Buyer Address 2": "buyer_Addr1",
          "Buyer Address 3": "buyer_Addr2",
          "Buyer Zipcode": "buyer_Zipcode",
          "Buyer City": "buyer_City",
          "Buyer State": "buyer_State",
          "Buyer Country": "buyer_Country",
          "Buyer Contact Number": "buyer_Contact",
          "Ship Recipient Name" : "shipRecipientName",
          "Ship Recipient Address 1" : "shipRecipientAddr0",
          "Ship Recipient Address 2" : "shipRecipientAddr1",
          "Ship Recipient Address 3" : "shipRecipientAddr2",
          "Ship Recipient Zipcode" : "shipRecipientZipCode",
          "Ship Recipient City" : "shipRecipientCity",
          "Ship Recipient State" : "shipRecipientState",
          "Ship Recipient Country" : "shipRecipientCountry",
          "Ship Recipient TIN" : "shipRecipientTin",
          "Ship Recipient Identification Type" : "shipRecipientBizType",
          "Ship Recipient Identification Value" : "shipRecipientBizValue",
          "Line Id": "lineId",
          "Line Classification Id": "classId",
          "Line Description": "lineDesc",
          "Line Unit Price": "unitPrice",
          "Line Tax Type": "taxTypeId",
          "Line Tax Rate": "taxRate",
          "Line Tax Amount": "taxAmt",
          "Line Tax Exemption Description": "tax_ExemptionDesc",
          "Line Tax Exemption Amount": "tax_ExemptAmt",
          "Line Total Amount": "total_LineAmt",
          "Line Total Exclude Tax": "total_ExcludeTax",
          "Line Quantity": "qty",
          "Line Unit of Measurement": "uom",
          "Line Discount Rate": "discRate",
          "Line Discount Amount": "discAmt",
          "Line Charge Rate": "chargeRate",
          "Line Charge Amount": "chargeAmt",
          "Line Tariff Code": "tariffCode",
          "Line Origin Country": "originCountry", //include line
        };
        return headerMapping[header] || header;
      },
    });
  };



  function transformAndUseData(parsedCsvData) {
    const invoices = []; 

    for (const row of parsedCsvData) {
      const { docNum, docDate, lineId } = row;
  
      // Validate date format
      if (!moment(docDate, "DD/MM/YYYY", true).isValid()) {
        ErrorAlert({
          message: `Error for invoice ${docNum}, line ${lineId}. The date must follow this format DD/MM/YYYY.`,
        });
        return;
      }

      if (docNum) {
        const docDetail = {
          tranId: 0,
          companyId: Number(companyId),
          docId: 0,
          lineId: row["lineId"],
          classId: row["classId"].toString().padStart(3, '0'),
          lineDesc: row["lineDesc"],
          unitPrice: Number(row["unitPrice"]).toFixed(2),
          taxTypeId: (row["taxTypeId"] === "" || row["taxTypeId"].toLowerCase() === "na") ? "Not Applicable" : row["taxTypeId"],
          taxRate: Number(row["taxRate"]).toFixed(2),
          taxAmt: Number(row["taxAmt"]).toFixed(2),
          tax_ExemptionDesc: row["tax_ExemptionDesc"],
          tax_ExemptAmt: (Number(row["tax_ExemptAmt"]).toFixed(2)),
          total_LineAmt: (Number(row["total_LineAmt"]).toFixed(2)),
          total_ExcludeTax: (Number(row["total_ExcludeTax"]).toFixed(2)),
          qty: Number(row["qty"]),
          uom: row["uom"],
          discRate: (Number(row["discRate"]).toFixed(2)),
          discAmt: (Number(row["discAmt"]).toFixed(2)),
          chargeRate: (Number(row["chargeRate"]).toFixed(2)),
          chargeAmt: (Number(row["chargeAmt"]).toFixed(2)),
          tariffCode: row["tariffCode"],
          originCountry: row["originCountry"],
          submissionuuid: "",
          docuuid: "",
          classdesc: "",
          taxtypedesc: "",
          longid: ""
        };
    
        let invoice = invoices.find((invoice) => invoice.docNum === docNum);
        if (invoice) {
          const existingDocDetail = invoice.docDetails.find(
            (detail) =>
              detail.lineId === docDetail.lineId &&
              detail.classId === docDetail.classId &&
              detail.lineDesc === docDetail.lineDesc &&
              detail.unitPrice === docDetail.unitPrice &&
              detail.taxTypeId === docDetail.taxTypeId &&
              detail.taxRate === docDetail.taxRate &&
              detail.taxAmt === docDetail.taxAmt &&
              detail.tax_ExemptionDesc === docDetail.tax_ExemptionDesc &&
              detail.tax_ExemptAmt === docDetail.tax_ExemptAmt &&
              detail.total_LineAmt === docDetail.total_LineAmt &&
              detail.total_ExcludeTax === docDetail.total_ExcludeTax &&
              detail.qty === docDetail.qty &&
              detail.uom === docDetail.uom &&
              detail.discRate === docDetail.discRate &&
              detail.discAmt === docDetail.discAmt &&
              detail.chargeRate === docDetail.chargeRate &&
              detail.chargeAmt === docDetail.chargeAmt &&
              detail.tariffCode === docDetail.tariffCode &&
              detail.originCountry === docDetail.originCountry
          );
          if (!existingDocDetail) {
            invoice.docDetails.push(docDetail);
          }
        } else {
          invoice = {
            id: 0,
            companyId: Number(companyId),
            docSource: "AR",
            version: parseFloat(row["version"]).toFixed(1),
            typeCode: "",
            typeCode_Value: row["typeCode_Value"],
            docNum: row["docNum"],
            refDocNum: row["refDocNum"],
            issueDateTime: todayDate,
            signature: "",
            currency: row["currency"],
            exchangeRate: (Number(row["exchangeRate"]).toFixed(6)),
            billFreq: row["billFreq"],
            docDate: moment(row["docDate"], "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm"),
            docDueDate: moment(row["docDate"], "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm"),
            payMode: "",
            payMode_Value: row["payMode_Value"],
            payTerm: row["payTerm"],
            depositAmt: (Number(row["depositAmt"]).toFixed(2)),
            depositDateTime: moment(row["depositDateTime"], "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm"),
            depositNum: row["depositNum"],
            depositRefNum: row["depositRefNum"],
            total_ExcludeTax: Number(row["total_ExcludeTax"]).toFixed(2),
            total_IncludeTax: Number(row["total_IncludeTax"]).toFixed(2),
            total_PayableAmt: Number(row["total_PayableAmt"]).toFixed(2),
            total_NettAmt: Number(row["total_NettAmt"]).toFixed(2),
            total_DiscAmt: Number(row["total_DiscAmt"]).toFixed(2),
            total_ChargeAmt: Number(row["total_ChargeAmt"]).toFixed(2),
            total_TaxAmt: Number(row["total_TaxAmt"]).toFixed(2),
            roundingAmt: Number(row["roundingAmt"]).toFixed(2),
            total_TaxableAmt: Number(row["total_TaxableAmt"]).toFixed(2),
            total_TaxTypeAmt: Number(row["total_TaxTypeAmt"]).toFixed(2),
            taxType: "",
            taxType_Value: row["taxType_Value"],
            status: "Open",
            remark: "",
            eDocNum: row["eDocNum"],

            supplier_Name: row["supplier_Name"],
            supplier_Tin: row["supplier_Tin"],
            supplier_BizType: row["supplier_BizType"],
            supplier_BizValue: row["supplier_BizValue"],
            supplier_SST: row["supplier_SST"],
            supplier_TourismTax: row["supplier_TourismTax"],
            supplier_Email: row["supplier_Email"],
            supplier_MSIC: row["supplier_MSIC"],
            supplier_BizType: row["supplier_BizType"],
            supplier_BizNature: row["supplier_BizNature"],
            supplier_Addr0: row["supplier_Addr0"],
            supplier_Addr1: row["supplier_Addr1"],
            supplier_Addr2: row["supplier_Addr2"],
            supplier_Zipcode: row["supplier_Zipcode"],
            supplier_City: row["supplier_City"],
            supplier_State: row["supplier_State"],
            supplier_Country: row["supplier_Country"],
            supplier_Contact: row["supplier_Contact"],
            buyer_BizType: row["buyer_BizType"],
            buyer_Name: row["buyer_Name"],
            buyer_Tin: row["buyer_Tin"],
            buyer_BizValue: row["buyer_BizValue"],
            buyer_SST: row["buyer_SST"],
            buyer_Email: row["buyer_Email"],
            buyer_Addr0: row["buyer_Addr0"],
            buyer_Addr1: row["buyer_Addr1"],
            buyer_Addr2: row["buyer_Addr2"],
            buyer_Zipcode: row["buyer_Zipcode"],
            buyer_City: row["buyer_City"],
            buyer_State: row["buyer_State"],
            buyer_Country: row["buyer_Country"],
            buyer_Contact: row["buyer_Contact"],
            validate_url: "",
            submitdate: todayDate,
            validatedate: todayDate,
            doclink: "",

            addedBy: localStorage.getItem("loggedInID"),
            addedDate: todayDate,
            updatedBy: localStorage.getItem("loggedInID"),
            updatedDate: todayDate,
            docDetails: [docDetail],
            longid: "",
            batch_id: "",
            ispicked: false,
            batch_success: false,
            isManualImport: true,

            importNum: row["importNum"],
            incoterms: row["incoterms"],
            ftaInfo: row["ftaInfo"] || "",
            exporterAcctId: row["exporterAcctId"] || "",
            exportNum: row["exportNum"] || "",
            
            shipRecipientName: row["shipRecipientName"] || "",
            shipRecipientAddr0: row["shipRecipientAddr0"] || "",
            shipRecipientAddr1: row["shipRecipientAddr1"] || "",
            shipRecipientAddr2: row["shipRecipientAddr2"] || "",
            shipRecipientZipCode: row["shipRecipientZipCode"] || "",
            shipRecipientCity: row["shipRecipientCity"] || "",
            shipRecipientState: row["shipRecipientState"] || "",
            shipRecipientCountry: row["shipRecipientCountry"] || "",
            shipRecipientTin: row["shipRecipientTin"] || "",
            shipRecipientBizType: row["shipRecipientBizType"] || "",
            shipRecipientBizValue: row["shipRecipientBizValue"] || "",
          };
          invoices.push(invoice);
        }
      }
    };
    setJsonData(invoices);
  }

  const handleOnChange = (e) => {
    setJsonData("")
    if (e.target.files[0]) {
      handleFileUpload(e.target.files[0]);
    }
  };

  const handleClickFile = () => {
    fileinputRef.current.value = null
  }

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    // Validate invoices
    const invalidInvoices = jsonData.filter(invoice =>
      invoice.typeCode_Value && invoice.typeCode_Value.includes("Self-billed")
    );

    // If there are invalid invoices, show error and stop
    if (invalidInvoices.length > 0) {
      toast.error("The invoice inserted is not one of AR invoices.", {
        position: "top-right",
      });
      return;
    }

    console.log('jsonData:', jsonData);
    
    
    try {
      for (const dataItem of jsonData) {
        const response = await axios.post(
          `${apiClient}/${companyId}/document/v2`,
          dataItem, // Send each object as payload
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              Accept: "application/json",
            },
          }
        );
      }

      toast.success("List receivable transactions created successfully.", {
        position: "top-right",
      });

      setOpen(false);
      setTimeout(() => {
        handleClose();
        window.location.reload();
      }, 800);
    } catch (error) {
      let errorList = error?.response?.data?.errors;

      for (let key in errorList) {
        toast.error(errorList[key][0], {
          position: "top-right",
          autoClose: 6000,
        });
      }

      toast.error(error?.response?.data, {
        position: "top-right",
        pauseOnFocusLoss: false,
      });
    } finally {
      setTimeout(() => {
        handleClose();
        // window.location.reload();
      }, 2000);
    }
  };

  return (
    <Box
      m={{ xs: 1, md: 2 }}
      sx={{
        display: "flex",
        alignItems: "end",
      }}
    >
      {localStorage.getItem("companyId") && (
      <Button variant="contained" onClick={handleOpen}>
        Import Invoices
      </Button>
      )} 

      <Modal
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose(event, reason);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 6,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <input
            accept="text/csv"
            ref={fileinputRef}
            id="contained-button-file"
            type="file"
            onChange={handleOnChange}
            onClick={handleClickFile}
            style={{ display: "none" }}
          />
          <label
            htmlFor="contained-button-file"
            style={{
              position: "relative",
              margin: "5px",
              padding: "8px 45px",
              marginTop: "10px",
              border: "1px #BBB",
              textAlign: "center",
              backgroundColor: "#DDD",
              cursor: "pointer",
            }}
          >
             Select a file
          </label>
          {jsonData && (
            <Box my={2} textAlign="center">
              <Box textAlign="center">
                <img
                  src={csvfile}
                  sx={{
                    width: "50%",
                    height: "auto",
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                />
              </Box>
              <Box
                display="inline-block"
                textAlign="center"
                width="50%"
              >
                <span>{fileName}</span>
              </Box>
            </Box>
          )}
          {jsonData && (
            <Button
              variant="contained"
              color="primary"
              component="span"
              onClick={(e) => {
                handleOnSubmit(e);
              }}
            >
              Upload
            </Button>
          )}
        </Box>
      </Modal>
    </Box>
  );
}

export default ImportButton;
